<template>
	<div>
		<div v-if="coachTaskListData && Object.keys(coachTaskListData).length">
			<h3>I task del tuo coach</h3>
			<TaskList :userInAssistance="userInAssistance"
			          :taskListData="coachTaskListData" />
		</div>

		<div v-if="taskListData && Object.keys(taskListData).length">
			<h3>I tuoi task</h3>
			<TeamTaskList :taskListData="taskListData" />
		</div>

		<div v-if="teamTaskListData && Object.keys(teamTaskListData).length">
			<h3>
				<span v-if="userData.owner_id">Task assegnati dal tuo coach</span>
				<span v-else>I task del tuo team</span>
			</h3>
			<TeamTaskList :taskListData="teamTaskListData" />
		</div>
	</div>
</template>
<script>
	import TaskList from '@/partials/supercoach/taskList'
	import TeamTaskList from '@/partials/supercoach/teamTaskList'
	import { mapActions, mapState } from 'vuex'

	export default {
		components: {
			TaskList,
			TeamTaskList
		},

		data() {
			return {
				firstCall: false
			}
		},

		created() {
			this.triggerTaskList();
		},

		watch: {
			userData(value) {
				if(value && Object.keys(value).length) {
					this.triggerTaskList();
				}
			}
		},

		computed: {
			...mapState('n_user', ['userData']),
			...mapState('n_supercoach', ['taskListData', 'teamTaskListData', 'coachTaskListData', 'userInAssistance']),
		},
		methods: {
			...mapActions('n_supercoach', ['taskList']),

			triggerTaskList() {
				console.log(this.userData)
				if(this.userData && Object.keys(this.userData).length) {
					this.taskList({ userId: this.userData.id })
				}
			}
		},
	}
</script>